<script setup lang="ts">
import { useCourseStore } from '../stores/courseStore';
import type { DayFilter } from '../types/course';
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useSwipe } from '@vueuse/core';
import { ref } from 'vue';

const store = useCourseStore();
const route = useRoute();
const tabsRef = ref<HTMLElement | null>(null);
const tapTimestamps = ref<number[]>([]);

const days: { id: DayFilter; label: string }[] = [
  { id: 'today', label: 'Heute' },
  { id: 'tomorrow', label: 'Morgen' },
  { id: 'day after tomorrow', label: 'Übermorgen' },
];

const getSelectedCoursesForDay = (day: DayFilter) => {
  return store.getSelectedCoursesCountForDay(day);
};

const showCounters = computed(() => store.selectedCategory === 'my day');

const isVisible = computed(() => route.path === '/schedule');

function handleDayClick(day: DayFilter) {
  if (day === 'today') {
    const now = Date.now();
    tapTimestamps.value.push(now);
    tapTimestamps.value = tapTimestamps.value.filter(t => now - t <= 5000);
    if (tapTimestamps.value.length >= 5) {
      store.showConductors = true;
      tapTimestamps.value = [];
    }
  }
  store.selectedDay = day;
}

// Add swipe functionality to day tabs
useSwipe(tabsRef, {
  onSwipeStart: (e) => {
    e.preventDefault();
  },
  onSwipe: (e) => {
    e.preventDefault();
  },
  onSwipeEnd: (e, direction) => {
    const currentIndex = days.findIndex(day => day.id === store.selectedDay);
    if (direction === 'left' && currentIndex < days.length - 1) {
      store.selectedDay = days[currentIndex + 1].id;
    } else if (direction === 'right' && currentIndex > 0) {
      store.selectedDay = days[currentIndex - 1].id;
    }
  }
});
</script>

<template>
  <div v-if="isVisible" class="day-tabs" ref="tabsRef">
    <button
      v-for="day in days"
      :key="day.id"
      :class="{ active: store.selectedDay === day.id }"
      @click="handleDayClick(day.id)"
    >
      {{ day.label }}
      <span v-if="showCounters" class="counter">
        {{ getSelectedCoursesForDay(day.id) }}
      </span>
    </button>
  </div>
</template>

<style scoped>
.day-tabs {
  display: flex;
  justify-content: space-around;
  background: #6b0030;
  padding: 0.5rem;
  touch-action: none;
}

button {
  background: none;
  border: none;
  color: white;
  padding: 0.5rem 1rem;
  cursor: pointer;
  opacity: 0.7;
  font-size: 0.9rem;
  position: relative;
}

button.active {
  opacity: 1;
  border-bottom: 2px solid white;
}

.counter {
  position: absolute;
  top: -8px;
  right: -8px;
  background: #ffd21f;
  color: #960040;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
}
</style>